/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

import { DAI_ZERO_REVIEW_MUTATION_RESULT_FIELDS } from '../fragments'

export const UNDO_HISTORICAL_DAI_ZERO_RELABELS = gql`
  ${DAI_ZERO_REVIEW_MUTATION_RESULT_FIELDS}
  mutation UndoHistoricalDAIZeroRelabels(
    $input: UndoHistoricalDAIZeroRelabelsInput!
  ) {
    undoHistoricalDaiZeroRelabels(input: $input) {
      ...DAIZeroReviewMutationResultFields
    }
  }
`
